import type { App } from 'vue'
import { inject } from 'vue'

export function installUserAgent(
    app: App,
    userAgent: string | undefined
): void {
    app.provide('$userAgent', userAgent)
}

export function useUserAgent(): string | undefined {
    return inject('$userAgent') as string | undefined
}
